var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9926 1.06131C17.1302 0.404568 18.5316 0.404567 19.6691 1.06131L31.4346 7.85414C32.5721 8.51087 33.2729 9.72458 33.2729 11.0381V24.6237C33.2729 25.9372 32.5721 27.1509 31.4346 27.8076L19.6691 34.6005C18.5316 35.2572 17.1302 35.2572 15.9926 34.6005L4.22712 27.8076C3.08962 27.1509 2.38889 25.9372 2.38889 24.6237V11.0381C2.38889 9.72458 3.08962 8.51087 4.22712 7.85414L15.9926 1.06131Z",
    fill: "url(#paint0_linear_3_888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1765 15.2934C17.2002 14.7024 18.4615 14.7024 19.4853 15.2934L31.6185 22.2985C32.6422 22.8896 33.2729 23.9819 33.2729 25.164V39.1742C33.2729 40.3563 32.6422 41.4487 31.6185 42.0397L19.4853 49.0448C18.4615 49.6359 17.2002 49.6359 16.1765 49.0448L4.0433 42.0397C3.01954 41.4487 2.38889 40.3563 2.38889 39.1742V25.164C2.38889 23.9819 3.01954 22.8896 4.0433 22.2985L16.1765 15.2934Z",
    fill: "url(#paint1_linear_3_888)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_888",
    x1: 17.8309,
    y1: 0,
    x2: 17.8309,
    y2: 35.6618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BD997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_888",
    x1: 17.8309,
    y1: 14.3382,
    x2: 17.8309,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4301FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D96BCE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e258c777d2cec1e64b64937202f1e8ec.svg";
export { ForwardRef as ReactComponent };